import {
  StyledButton,
  StyledMultilineTextField,
  StyledTableCellHistory,
  StyledTableRowHistory,
  StyledTextField,
} from "../../StyledComponents";
import "./Dental.css";
import "./Teath.css";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import {
  Button,
  Card,
  Grid,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
const Dental = ({ dentalData, setDentalData }) => {
  const [isPrimary, setIsPrimary] = useState(false);
  const [isIndividual, setIsIndividual] = useState(true);
  const [isQuadrants, setIsQuadrants] = useState(false);
  const [isJaw, setIsJaw] = useState(false);

  const [selectedTeeth, setSelectedTeeth] = useState([]);
  const [clinicalNote, setClinicalNote] = useState("");
  const [notesArray, setNotesArray] = useState(dentalData);
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const [selectedQuadrant, setSelectedQuadrant] = useState(null);
  const [selectedJaw, setSelectedJaw] = useState(null);

  useEffect(() => {
    setNotesArray(dentalData);
  }, [dentalData]);

  console.log("notes Array", notesArray);

  const all = [
    "1_8",
    "1_7",
    "1_6",
    "1_5",
    "1_4",
    "1_3",
    "1_2",
    "1_1",
    "5_5",
    "5_4",
    "5_3",
    "5_2",
    "5_1",
    "2_1",
    "2_2",
    "2_3",
    "2_4",
    "2_5",
    "2_6",
    "2_7",
    "2_8",
    "6_1",
    "6_2",
    "6_3",
    "6_4",
    "6_5",
    "3_1",
    "3_2",
    "3_3",
    "3_4",
    "3_5",
    "3_6",
    "3_7",
    "3_8",
    "7_1",
    "7_2",
    "7_3",
    "7_4",
    "7_5",
    "4_1",
    "4_2",
    "4_3",
    "4_4",
    "4_5",
    "4_6",
    "4_7",
    "4_8",
    "8_1",
    "8_2",
    "8_3",
    "8_4",
    "8_5",
  ];
  const Q1 = [
    "1_8",
    "1_7",
    "1_6",
    "1_5",
    "1_4",
    "1_3",
    "1_2",
    "1_1",
    "5_5",
    "5_4",
    "5_3",
    "5_2",
    "5_1",
  ];
  const Q2 = [
    "2_1",
    "2_2",
    "2_3",
    "2_4",
    "2_5",
    "2_6",
    "2_7",
    "2_8",
    "6_1",
    "6_2",
    "6_3",
    "6_4",
    "6_5",
  ];
  const Q3 = [
    "3_1",
    "3_2",
    "3_3",
    "3_4",
    "3_5",
    "3_6",
    "3_7",
    "3_8",
    "7_1",
    "7_2",
    "7_3",
    "7_4",
    "7_5",
  ];
  const Q4 = [
    "4_1",
    "4_2",
    "4_3",
    "4_4",
    "4_5",
    "4_6",
    "4_7",
    "4_8",
    "8_1",
    "8_2",
    "8_3",
    "8_4",
    "8_5",
  ];
  const upperSet = [
    "1_8",
    "1_7",
    "1_6",
    "1_5",
    "1_4",
    "1_3",
    "1_2",
    "1_1",
    "2_1",
    "2_2",
    "2_3",
    "2_4",
    "2_5",
    "2_6",
    "2_7",
    "2_8",
    "5_5",
    "5_4",
    "5_3",
    "5_2",
    "5_1",
    "6_1",
    "6_2",
    "6_3",
    "6_4",
    "6_5",
  ];
  const lowerSet = [
    "4_8",
    "4_7",
    "4_6",
    "4_5",
    "4_4",
    "4_3",
    "4_2",
    "4_1",
    "3_1",
    "3_2",
    "3_3",
    "3_4",
    "3_5",
    "3_6",
    "3_7",
    "3_8",
    "8_5",
    "8_4",
    "8_3",
    "8_2",
    "8_1",
    "7_1",
    "7_2",
    "7_3",
    "7_4",
    "7_5",
  ];

  // For Reset Item / Set
  const viewReset = () => {
    all.map((i) => {
      const item = document.getElementById(i);
      const defultClass = "fa-teath_Defult_" + i;
      const selectedClass = "fa-teath_Selected_" + i;
      const defult = document.getElementsByClassName(defultClass);
      const selected = document.getElementsByClassName(selectedClass);

      if (defult.length == 0 && selected.length != 0) {
        selected[0].className = "svgIcon " + defultClass;
        item?.classList.remove("active");
      }
    });
  };

  // For Toggle Primery Button
  const toggle = () => {
    setIsPrimary((prevState) => !prevState);
  };

  // For Individual Tab
  const individual = () => {
    setSelectedTeeth([]);
    setClinicalNote("");
    setIsQuadrants(false);
    setIsJaw(false);
    setIsIndividual(true);
    document.getElementById("teathWaper").classList.add("individual");
    document.getElementById("teathWaper").classList.remove("quadrants");
    document.getElementById("teathWaper").classList.remove("jaw");
    viewReset();
  };
  // For Quadrants Tab
  const quadrants = () => {
    setSelectedTeeth([]);
    setClinicalNote("");
    setIsIndividual(false);
    setIsJaw(false);
    setIsQuadrants(true);
    document.getElementById("teathWaper").classList.add("quadrants");
    document.getElementById("teathWaper").classList.remove("individual");
    document.getElementById("teathWaper").classList.remove("jaw");
    viewReset();
  };
  // For Jaw Tab
  const jaw = () => {
    setSelectedTeeth([]);
    setClinicalNote("");
    setIsIndividual(false);
    setIsQuadrants(false);
    setIsJaw(true);
    document.getElementById("teathWaper").classList.add("jaw");
    document.getElementById("teathWaper").classList.remove("quadrants");
    document.getElementById("teathWaper").classList.remove("individual");
    viewReset();
  };
  // for Select Individual
  const selecteIndividual = (_id) => {
    const item = document.getElementById(_id);

    if (isIndividual) {
      const defultClass = "fa-teath_Defult_" + _id;
      const selectedClass = "fa-teath_Selected_" + _id;

      const defult = document.getElementsByClassName(defultClass);
      const selected = document.getElementsByClassName(selectedClass);

      if (selected.length == 0) {
        defult[0].className = "svgIcon " + selectedClass;
        item?.classList.add("active");
        // alert(_id);
        handleToothClick(_id);
      } else if (defult.length == 0) {
        selected[0].className = "svgIcon " + defultClass;
        item?.classList.remove("active");
        handleToothClick(_id);
      }
    }
  };
  // for Select Quadrants
  const quadrantsTeath = (_id) => {
    if (isQuadrants) {
      viewReset();
      if (_id == "q_top_Left") {
        selectSet(Q1);
        // toast("Q1");
        handleQuadrantClick("Q1", Q1);
      } else if (_id == "q_top_Right") {
        selectSet(Q2);
        // toast("Q2");
        handleQuadrantClick("Q2", Q2);
      } else if (_id == "q_bottom_Left") {
        selectSet(Q4);
        // toast("Q4");
        handleQuadrantClick("Q4", Q4);
      } else if (_id == "q_bottom_Right") {
        selectSet(Q3);
        // toast("Q3");
        handleQuadrantClick("Q3", Q3);
      }
    }
  };
  // for Select jawTeath
  const jawTeath = (_id) => {
    if (isJaw) {
      viewReset();

      if (_id == "q_btm_rigth_top") {
        selectSet(upperSet);
        handleJawClick("Upper Set", upperSet);
      } else if (_id == "q_btm_rigth_bottom") {
        selectSet(lowerSet);
        handleJawClick("Lower Set", lowerSet);
      }
    }
  };

  // For Select Set
  const selectSet = (_arr) => {
    _arr.map((i) => {
      const item = document.getElementById(i);
      const defultClass = "fa-teath_Defult_" + i;
      const selectedClass = "fa-teath_Selected_" + i;
      const defult = document.getElementsByClassName(defultClass);
      const selected = document.getElementsByClassName(selectedClass);

      if (selected.length == 0 && defult.length != 0) {
        defult[0].className = "svgIcon " + selectedClass;
        item?.classList.add("active");
      } else if (defult.length == 0 && selected.length != 0) {
        selected[0].className = "svgIcon " + defultClass;
        item?.classList.remove("active");
      }
    });
  };

  const handleToothClick = (toothId) => {
    setSelectedTeeth((prev) => {
      const updatedTeeth = prev.includes(toothId)
        ? prev.filter((id) => id !== toothId)
        : [...prev, toothId];
      return updatedTeeth;
    });
  };
  const handleQuadrantClick = (quadrantId, teeth) => {
    setSelectedQuadrant(quadrantId);
    setSelectedTeeth(!isPrimary ? teeth.slice(0, 8) : teeth.slice(-5));
  };
  const handleJawClick = (jawId, teeth) => {
    setSelectedJaw(jawId);
    setSelectedTeeth(!isPrimary ? teeth.slice(0, 16) : teeth.slice(-10));
  };

  const handleAddOrUpdate = () => {
    if (selectedTeeth.length === 0 && clinicalNote.trim()) {
      toast.error("Please select atleast one tooth");
    }
    if (selectedTeeth.length === 0 || !clinicalNote.trim()) return;

    const updatedNotes = [...notesArray];
    let formattedToothIds;
    if (isIndividual && !isQuadrants && !isJaw) {
      formattedToothIds = selectedTeeth.join(", "); // Ensure comma separation
    } else if (isQuadrants && !isJaw) {
      formattedToothIds = `${selectedQuadrant}( ${selectedTeeth.join(", ")} )`;
    } else {
      formattedToothIds = `${selectedJaw}( ${selectedTeeth.join(", ")} )`;
    }
    if (isEditing && editIndex !== null) {
      updatedNotes[editIndex] = {
        id: formattedToothIds,
        clinical_note: clinicalNote,
      };
    } else {
      updatedNotes.push({ id: formattedToothIds, clinical_note: clinicalNote });
    }

    // Reset visual state of selected teeth
    viewReset();

    // Reset state variables
    setNotesArray(updatedNotes);
    setDentalData(updatedNotes);
    setSelectedTeeth([]);
    setClinicalNote("");
    setIsEditing(false);
    setEditIndex(null);
  };

  const handleEdit = (index) => {
    viewReset();
    const noteToEdit = notesArray[index];
    let selectedTeethForEdit = [];
    let selectedQuadrantForEdit = null;
    let selectedJawForEdit = null;

    if (noteToEdit.id.includes("(") && noteToEdit.id.includes(")")) {
      // It's a Quadrant or Jaw case
      const match = noteToEdit.id.match(/\(([^)]+)\)/);

      if (match) {
        selectedTeethForEdit = match[1].split(",").map((id) => id.trim()); // Convert to array

        if (noteToEdit.id.startsWith("Q")) {
          quadrants();
          selectedQuadrantForEdit = noteToEdit.id.slice(0, 2);
        } else if (noteToEdit.id.includes("Set")) {
          jaw();
          selectedJawForEdit = noteToEdit.id.slice(0, 9);
        }
      }
    } else {
      // Individual teeth case (single or multiple, separated by commas)
      individual();
      selectedTeethForEdit = noteToEdit.id.split(",").map((id) => id.trim()); // Convert to array
    }

    setSelectedTeeth(selectedTeethForEdit);
    setClinicalNote(noteToEdit.clinical_note);
    setIsEditing(true);
    setEditIndex(index);

    setSelectedQuadrant(selectedQuadrantForEdit);
    setSelectedJaw(selectedJawForEdit);

    // Visually mark selected teeth as active
    selectedTeethForEdit.forEach((toothId) => {
      const item = document.getElementById(toothId);
      if (item) {
        const defaultClass = `fa-teath_Defult_${toothId}`;
        const selectedClass = `fa-teath_Selected_${toothId}`;
        const defult = document.getElementsByClassName(defaultClass);

        if (defult.length > 0) {
          defult[0].className = `svgIcon ${selectedClass}`;
          item.classList.add("active");
        }
      }
    });
  };

  const handleDelete = (index) => {
    setNotesArray((prevNotes) => prevNotes.filter((_, i) => i !== index));
    setDentalData((prevNotes) => prevNotes.filter((_, i) => i !== index));
  };
  const handleCancel = (index) => {
    // Reset visual state of selected teeth
    viewReset();

    // Reset state variables
    setSelectedTeeth([]);
    setClinicalNote("");
    setIsEditing(false);
    setEditIndex(null);
  };

  // useEffect(() => {
  //   //reset selected items when radio buttons change
  //   setSelectedTeeth([]);
  //   setSelectedQuadrant(null);
  //   setSelectedJaw(null);
  // }, [isIndividual, isQuadrants, isJaw, isPrimary]);

  return (
    <Card
      sx={{
        borderRadius: "10px",
        boxShadow: "0 4px 4px 0 #C7C7CC inset",
        backgroundColor: "#FFF",
      }}
    >
      <div className="Dental">
        <div className="dentalWapper">
          {/* <ToastContainer /> */}
          <div className="dentalWapperLeft">
            <div className="dentalWapperLeftHeading">
              {/* <h2>Notes</h2> */}
              {isIndividual && selectedTeeth?.length > 0 ? (
                <span>
                  Selected Tooth FDI No. :
                  {selectedTeeth
                    .map((id) => id.replace("_", "")) // Remove underscore
                    .join(",") || // Join back with commas
                    ""}
                </span>
              ) : (
                ""
              )}
              {isQuadrants && selectedTeeth?.length > 0 ? (
                <span>
                  Selected Quadrant: {selectedQuadrant}(
                  {selectedTeeth
                    .map((id) => id.replace("_", "")) // Remove underscore
                    .join(",") || // Join back with commas
                    ""}
                  )
                </span>
              ) : (
                ""
              )}
              {isJaw && selectedTeeth?.length > 0 ? (
                <span>
                  Selected Jaw: {selectedJaw}(
                  {selectedTeeth
                    .map((id) => id.replace("_", "")) // Remove underscore
                    .join(",") || // Join back with commas
                    ""}
                  )
                </span>
              ) : (
                ""
              )}
            </div>

            <Grid container spacing={1} style={{ marginTop: "1%" }}>
              <Grid item xs={12} sm={12}>
                <StyledMultilineTextField
                  value={clinicalNote}
                  onChange={(e) => setClinicalNote(e.target.value)}
                  placeholder="Clinical Notes"
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <StyledButton
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleAddOrUpdate}
                  style={{ float: "right" }}
                  bgColor="#0E3F66"
                  textColor="#FDFDFD"
                  sx={{ height: "70%", width: "50%" }}
                >
                  {isEditing ? "UPDATE" : "ADD"}
                </StyledButton>
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledButton
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleCancel}
                  bgColor="#E9E9E9"
                  textColor="#171717"
                  sx={{ height: "70%", width: "50%" }}
                >
                  CANCEL
                </StyledButton>
              </Grid>
            </Grid>
          </div>
          <div className="dentalWapperRight">
            <div className="dentalWapperRightHeading">
              <ul>
                <li onClick={individual}>
                  <input
                    type="radio"
                    id="individual"
                    name="teathview"
                    value="individual"
                    // defaultChecked
                    checked={isIndividual}
                  />{" "}
                  <label className="radioLabel" for="individual">
                    Individual
                  </label>
                </li>
                <li onClick={quadrants}>
                  <input
                    type="radio"
                    id="quadrants"
                    name="teathview"
                    value="quadrants"
                    checked={isQuadrants}
                  />
                  <label className="radioLabel" for="quadrants">
                    Quadrants
                  </label>
                </li>
                <li onClick={jaw}>
                  <input
                    type="radio"
                    id="jaw"
                    name="teathview"
                    value="jaw"
                    checked={isJaw}
                  />
                  <label className="radioLabel" for="jaw">
                    Jaw
                  </label>
                </li>
              </ul>
              <div
                className="customToggle"
                // onClick={toggle}
              >
                <label className="switch">
                  {/* <input type="checkbox" /> */}
                  <input
                    type="checkbox"
                    checked={isPrimary}
                    onChange={toggle}
                  />
                  <span className="slider round"></span>
                </label>
                <label>Primary Teeth</label>
                {/* Primary Teeth */}
              </div>
            </div>
          </div>
          <div className="dentalWapperBody">
            <div className="dentalWapperBodyLeft">
              <Grid item xs={12}>
                <TableContainer
                  component={Paper}
                  sx={{
                    margin: "10px 5px",
                    border: "1px solid #21cdc0",
                    overflowX: "auto",
                    width: "100%",
                  }}
                >
                  <Table sx={{ minWidth: 100 }}>
                    <TableHead>
                      <StyledTableRowHistory>
                        <StyledTableCellHistory>
                          Teeth FDI No.
                        </StyledTableCellHistory>
                        <StyledTableCellHistory>
                          Clinical Notes
                        </StyledTableCellHistory>
                        <StyledTableCellHistory>Actions</StyledTableCellHistory>
                      </StyledTableRowHistory>
                    </TableHead>

                    <TableBody>
                      {notesArray.map((note, index) => (
                        <StyledTableRowHistory key={index}>
                          <StyledTableCellHistory>
                            {
                              note.id
                                .split(",") // Split by comma to handle multiple IDs
                                .map((id) => id.replace("_", "")) // Remove underscore
                                .join(",") // Join back with commas
                            }
                            {note?.source === "voice" && (
                              <Tooltip title="Machine-interpreted text — please verify before confirming">
                                <span className="missing-id-warning">⚠️</span>
                              </Tooltip>
                            )}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {note.clinical_note}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory
                            // style={{
                            //   display: "flex",
                            //   justifyContent: "center",
                            //   alignItems: "center",
                            // }}
                          >
                            <div style={{width:"100%", height:"100%",display:"flex",alignItems:"center",justifyContent:"center"}}>
                              <EditIcon
                                style={{ cursor: "pointer" }}
                                onClick={() => handleEdit(index)}
                              />
                              <DeleteIcon
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDelete(index)}
                              />
                            </div>
                          </StyledTableCellHistory>
                        </StyledTableRowHistory>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </div>

            <div className="dentalWapperBodyRight individual" id="teathWaper">
              <div
                className="dentalWapperBodyRightTop"
                id="q_btm_rigth_top"
                onClick={() => {
                  jawTeath("q_btm_rigth_top");
                }}
              >
                <div
                  className="dentalWapperBodyRightTopLeft"
                  id="q_top_Left"
                  onClick={() => {
                    quadrantsTeath("q_top_Left");
                  }}
                >
                  {!isPrimary ? (
                    <ul className="notPrimery">
                      <li
                        onClick={() => {
                          selecteIndividual("1_8");
                        }}
                        id="1_8"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_1_8">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">18</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("1_7");
                        }}
                        id="1_7"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_1_7">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">17</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("1_6");
                        }}
                        id="1_6"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_1_6">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">16</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("1_5");
                        }}
                        id="1_5"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_1_5">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">15</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("1_4");
                        }}
                        id="1_4"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_1_4">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">14</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("1_3");
                        }}
                        id="1_3"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_1_3">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">13</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("1_2");
                        }}
                        id="1_2"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_1_2">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">12</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("1_1");
                        }}
                        id="1_1"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_1_1">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">11</span>
                        </div>
                      </li>
                    </ul>
                  ) : null}
                  {isPrimary ? (
                    <ul className="primery">
                      <li
                        onClick={() => {
                          selecteIndividual("5_5");
                        }}
                        id="5_5"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_5_5">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">55</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("5_4");
                        }}
                        id="5_4"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_5_4">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">54</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("5_3");
                        }}
                        id="5_3"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_5_3">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">53</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("5_2");
                        }}
                        id="5_2"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_5_2">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">52</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("5_1");
                        }}
                        id="5_1"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_5_1">
                            <i className="fa fa-teath " aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">51</span>
                        </div>
                      </li>
                    </ul>
                  ) : null}
                </div>
                <div
                  className="dentalWapperBodyRightTopRight"
                  id="q_top_Right"
                  onClick={() => {
                    quadrantsTeath("q_top_Right");
                  }}
                >
                  {!isPrimary ? (
                    <ul className="notPrimery">
                      <li
                        onClick={() => {
                          selecteIndividual("2_1");
                        }}
                        id="2_1"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_2_1">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">21</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("2_2");
                        }}
                        id="2_2"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_2_2">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">22</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("2_3");
                        }}
                        id="2_3"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_2_3">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">23</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("2_4");
                        }}
                        id="2_4"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_2_4">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">24</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("2_5");
                        }}
                        id="2_5"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_2_5">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">25</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("2_6");
                        }}
                        id="2_6"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_2_6">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">26</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("2_7");
                        }}
                        id="2_7"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_2_7">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">27</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("2_8");
                        }}
                        id="2_8"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_2_8">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">28</span>
                        </div>
                      </li>
                    </ul>
                  ) : null}
                  {isPrimary ? (
                    <ul className="primery">
                      <li
                        onClick={() => {
                          selecteIndividual("6_1");
                        }}
                        id="6_1"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_6_1">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">61</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("6_2");
                        }}
                        id="6_2"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_6_2">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">62</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("6_3");
                        }}
                        id="6_3"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_6_3">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">63</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("6_4");
                        }}
                        id="6_4"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_6_4">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">64</span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("6_5");
                        }}
                        id="6_5"
                      >
                        <div className="teathItem">
                          <span className="svgIcon fa-teath_Defult_6_5">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                          <span className="NumberText">65</span>
                        </div>
                      </li>
                    </ul>
                  ) : null}
                </div>
              </div>
              <div
                className="dentalWapperBodyRightBottom"
                id="q_btm_rigth_bottom"
                onClick={() => {
                  jawTeath("q_btm_rigth_bottom");
                }}
              >
                <div
                  className="dentalWapperBodyRightBottomLeft"
                  id="q_bottom_Left"
                  onClick={() => {
                    quadrantsTeath("q_bottom_Left");
                  }}
                >
                  {!isPrimary ? (
                    <ul className="notPrimery">
                      <li
                        onClick={() => {
                          selecteIndividual("4_8");
                        }}
                        id="4_8"
                      >
                        <div className="teathItem">
                          <span className="NumberText">48</span>
                          <span className="svgIcon fa-teath_Defult_4_8">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("4_7");
                        }}
                        id="4_7"
                      >
                        <div className="teathItem">
                          <span className="NumberText">47</span>
                          <span className="svgIcon fa-teath_Defult_4_7">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("4_6");
                        }}
                        id="4_6"
                      >
                        <div className="teathItem">
                          <span className="NumberText">46</span>
                          <span className="svgIcon fa-teath_Defult_4_6">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("4_5");
                        }}
                        id="4_5"
                      >
                        <div className="teathItem">
                          <span className="NumberText">45</span>
                          <span className="svgIcon fa-teath_Defult_4_5">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("4_4");
                        }}
                        id="4_4"
                      >
                        <div className="teathItem">
                          <span className="NumberText">44</span>
                          <span className="svgIcon fa-teath_Defult_4_4">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("4_3");
                        }}
                        id="4_3"
                      >
                        <div className="teathItem">
                          <span className="NumberText">43</span>
                          <span className="svgIcon fa-teath_Defult_4_3">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("4_2");
                        }}
                        id="4_2"
                      >
                        <div className="teathItem">
                          <span className="NumberText">42</span>
                          <span className="svgIcon fa-teath_Defult_4_2">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("4_1");
                        }}
                        id="4_1"
                      >
                        <div className="teathItem">
                          <span className="NumberText ">41</span>
                          <span className="svgIcon fa-teath_Defult_4_1">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                    </ul>
                  ) : null}
                  {isPrimary ? (
                    <ul className="primery">
                      <li
                        onClick={() => {
                          selecteIndividual("8_5");
                        }}
                        id="8_5"
                      >
                        <div className="teathItem">
                          <span className="NumberText">85</span>
                          <span className="svgIcon fa-teath_Defult_8_5">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("8_4");
                        }}
                        id="8_4"
                      >
                        <div className="teathItem">
                          <span className="NumberText">84</span>
                          <span className="svgIcon fa-teath_Defult_8_4">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("8_3");
                        }}
                        id="8_3"
                      >
                        <div className="teathItem">
                          <span className="NumberText">83</span>
                          <span className="svgIcon fa-teath_Defult_8_3">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("8_2");
                        }}
                        id="8_2"
                      >
                        <div className="teathItem">
                          <span className="NumberText">82</span>
                          <span className="svgIcon fa-teath_Defult_8_2">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("8_1");
                        }}
                        id="8_1"
                      >
                        <div className="teathItem">
                          <span className="NumberText ">81</span>
                          <span className="svgIcon fa-teath_Defult_8_1">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                    </ul>
                  ) : null}
                </div>
                <div
                  className="dentalWapperBodyRightBottomRight"
                  id="q_bottom_Right"
                  onClick={() => {
                    quadrantsTeath("q_bottom_Right");
                  }}
                >
                  {!isPrimary ? (
                    <ul className="notPrimery">
                      <li
                        onClick={() => {
                          selecteIndividual("3_1");
                        }}
                        id="3_1"
                      >
                        <div className="teathItem">
                          <span className="NumberText">31</span>
                          <span className="svgIcon fa-teath_Defult_3_1">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("3_2");
                        }}
                        id="3_2"
                      >
                        <div className="teathItem">
                          <span className="NumberText">32</span>
                          <span className="svgIcon fa-teath_Defult_3_2">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("3_3");
                        }}
                        id="3_3"
                      >
                        <div className="teathItem">
                          <span className="NumberText">33</span>
                          <span className="svgIcon fa-teath_Defult_3_3">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("3_4");
                        }}
                        id="3_4"
                      >
                        <div className="teathItem">
                          <span className="NumberText">34</span>
                          <span className="svgIcon fa-teath_Defult_3_4">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("3_5");
                        }}
                        id="3_5"
                      >
                        <div className="teathItem">
                          <span className="NumberText">35</span>
                          <span className="svgIcon fa-teath_Defult_3_5">
                            <i className="fa fa-teath " aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("3_6");
                        }}
                        id="3_6"
                      >
                        <div className="teathItem">
                          <span className="NumberText">36</span>
                          <span className="svgIcon fa-teath_Defult_3_6">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("3_7");
                        }}
                        id="3_7"
                      >
                        <div className="teathItem">
                          <span className="NumberText">37</span>
                          <span className="svgIcon fa-teath_Defult_3_7">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("3_8");
                        }}
                        id="3_8"
                      >
                        <div className="teathItem">
                          <span className="NumberText">38</span>
                          <span className="svgIcon fa-teath_Defult_3_8">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                    </ul>
                  ) : null}
                  {isPrimary ? (
                    <ul className="primery">
                      <li
                        onClick={() => {
                          selecteIndividual("7_1");
                        }}
                        id="7_1"
                      >
                        <div className="teathItem">
                          <span className="NumberText">71</span>
                          <span className="svgIcon fa-teath_Defult_7_1">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("7_2");
                        }}
                        id="7_2"
                      >
                        <div className="teathItem">
                          <span className="NumberText">72</span>
                          <span className="svgIcon fa-teath_Defult_7_2">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("7_3");
                        }}
                        id="7_3"
                      >
                        <div className="teathItem">
                          <span className="NumberText">73</span>
                          <span className="svgIcon fa-teath_Defult_7_3">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("7_4");
                        }}
                        id="7_4"
                      >
                        <div className="teathItem">
                          <span className="NumberText">74</span>
                          <span className="svgIcon fa-teath_Defult_7_4">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                      <li
                        onClick={() => {
                          selecteIndividual("7_5");
                        }}
                        id="7_5"
                      >
                        <div className="teathItem">
                          <span className="NumberText">75</span>
                          <span className="svgIcon fa-teath_Defult_7_5">
                            <i className="fa fa-teath" aria-hidden="true"></i>
                          </span>
                        </div>
                      </li>
                    </ul>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default Dental;
